module.exports = __webpack_public_path__ + "static/project-7-cee5af349f00e368180d5de12c16d66d.jpg";